import { Upload } from "tus-js-client";

type UploadTask = UploadItem & {
	upload?: Upload;
};

export class UploadService {
	private uploads = new Map<string, UploadTask>();

	startUpload(uuid: string, file: File, uploadUrl: string) {
		const upload = new Upload(file, {
			chunkSize: 5 * 1024 * 1024,
			metadata: { filename: file.name, filetype: file.type },
			onError: error => {
				const task = this.uploads.get(uuid);
				if (task) {
					task.status = "ERROR";
					task.error = error?.message || "Upload failed!";
				}
			},
			onProgress: (bytesSent, bytesTotal) => {
				const task = this.uploads.get(uuid);
				if (task) {
					task.progress = (bytesSent / bytesTotal) * 100;
				}
			},
			onSuccess: () => {
				const task = this.uploads.get(uuid);
				if (task) {
					task.status = "COMPLETED";
				}
			},
			removeFingerprintOnSuccess: true,
			retryDelays: [0, 1000, 3000, 5000],
			storeFingerprintForResuming: true,
			uploadUrl,
		});

		const uploadTask: UploadTask = { uuid, file, uploadUrl, upload, progress: 0, status: "UPLOADING" };
		this.uploads.set(uuid, uploadTask);
		upload.start();

		return uploadTask;
	}

	resumeUpload(uuid: string) {
		const task = this.uploads.get(uuid);
		if (task?.upload) {
			task.upload.start();
			task.status = "UPLOADING";
		}
	}

	stopUpload(uuid: string) {
		const task = this.uploads.get(uuid);
		if (task?.upload) {
			task.upload.abort();
			task.status = "STOPPED";
		}
	}

	deleteUpload(uuid: string) {
		this.uploads.delete(uuid);
	}
}

export const uploadService = new UploadService();
